import { render, staticRenderFns } from "./dispositivos.vue?vue&type=template&id=621ea6f0"
import script from "./dispositivos.vue?vue&type=script&lang=js"
export * from "./dispositivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports